import { Link } from "react-router-dom"; 

const helps = [
  {
    id: "InsightNoteAI_Learning_Data",
    title: "AIはどのようなデータを学習してますか?",
    description:
    `AIの回答のもととなるデータはどのようなデータですか？
    データの信憑性について教えてください。`,
    help: 
      `InsightnoteAIが参照し回答するデータは企業の1次情報のみです。
      日本、米国の有価証券報告書、および適時開示を使用しています。
      AIはユーザーの質問に応じて必要な資料を判断し、それをもとに回答します。
      これらの資料から適切な回答が得られない場合は、回答を控えます。
      よって、web上の曖昧な情報からの回答やハルシネーションを避けることができます。`,
    largeCategory: "サービスについて",
    middleCategory: ["データ", "AI"],
    date: "2024-01-06"
  },
  {
    id: "Dashboard_Sources",
    title: "ダッシュボードに表示されているデータの参照元は?",
    description:
    `ダッシュボードに表示されているデータはどのようなデータですか？
    データの参照元を教えてください。`,
    help: 
      `企業ダッシュボードのデータは、日本の金融庁が運営するEDINETやSECが運営するEdgarに提出された各企業の有価証券報告書を加工したものとなります。
      株価等の1部のデータにつきましては海外のデータプロバイダーを通してデータを取得しています。`,
    largeCategory: "サービスについて",
    middleCategory: ["データ", "ダッシュボード"],
    date: "2024-01-07"
  },
  {
    id: "Pricing_Beta",
    title: "無料で利用することは可能ですか？",
    description:
    `無料で利用することは可能ですか？
    また有料版について料金を教えてください。`,
    help: 
      `現在(2024/01/08)はBeta版のみの提供のため、全ての機能を無料でお試しいただけます。
      Beta版は予告なく終了することがあります。`,
    largeCategory: "料金について",
    middleCategory: ["Beta版"],
    date: "2024-01-08"
  },
  {
    id: "Commercial_Plan",
    title: "法人プランはありますか?",
    description:
    `法人向けのプランについて価格やサービス内容を教えてください。`,
    help: 
      `現在(2024/01/08)はBeta版のみの提供のため、法人向けの提供はございません。`,
    largeCategory: "料金について",
    middleCategory: ["Beta版"],
    date: "2024-01-08"
  },
];

export default helps;
